export const environment = {
  baseUrl: 'http://localhost:4200',
  deployedUrl: 'https://nettfart.no',
  availableLangs: [
    { iso: 'en', name: 'English' },
    { iso: 'nb', name: 'Norsk' },
  ],
  defaultLang: 'nb',
  cms: {
    headers: {
      'Content-Type': 'application/json',
    },
    projectSlug: 'no',
    type: 'strapi',
    url: 'https://portal-api.nettest.org',
    routes: {
      articles: '/articles',
      export: '/export',
      exportQueue: '/dataStream',
      feedback: '/feedback',
      menus: '/header-menus',
      municipalities: '/municipalities',
      translations: '/ui-translations',
      images: '/assets/images',
      clearExport: '/dataStream/remove',
      cookiesProject: '/cookies/project',
      cookieConsents: '/cookie-consents',
      pages: '/pages',
      pagesProject: '/pages/project',
      projects: '/projects',
      scheduleExport: '/public/mobile',
      uploads: '/upload/files',
      versions: '/versions',
    },
  },
  controlServer: {
    headers: {
      'Content-Type': 'application/json',
      'X-Nettest-Client': 'no',
    },
    url: 'https://api.nettest.org',
    routes: {
      providers: '/nationalTable',
      history: '/reports/basic/history',
      result: '/measurementResult',
      measurementServer: '/measurementServer',
      settings: '/settings',
      speedCurve: '/mobile/graphs',
    },
  },
  cookieWidget: {
    theme: {
      altTextColor: '#345FED',
      backgroundColor: 'white',
      buttonColor: '#345FED',
      disabledSwitchColor: 'black',
      disabledSwitchButtonColor: '#bdbdbd',
      dropdownColor: '#2B3551',
      dropdownTextColor: 'white',
      linkColor: '#345FED',
      progressColor: 'white',
      textColor: 'black',
    },
  },
  countriesUrl:
    'https://portal-api.nettest.org/uploads/countries_a13e3c594f.json',
  production: true,
  projectTitle: 'Nettfart',
  logo: {
    header: '/assets/images/logo-header.png',
    headerSide: null,
    footer: '/assets/images/logo-footer.svg',
    map: '/assets/images/logo-header-map.png',
  },
  map: {
    center: [13.85903, 66.082947],
    styleUrl:
      'https://tileserver.nettest.com/styles/norway_world_web/style.json',
    ispStyleUrl: null,
    allStyleUrl: null,
    browserStyleUrl: null,
    zoom: 4,
    countiesMaxZoom: 5,
    geocoding: {
      url:
        'https://geocode.search.hereapi.com/v1/geocode' +
        '?q={query}' +
        '&at={center}',
      apiKey: '5I4w2plz9lDIxz2F7XuEjgHNk8voUubHKatZHW0sci0',
      limit: 10,
      provider: 'here',
      region: 'NOR',
    },
    municipalitiesMaxZoom: 7.5,
    hexagons10kmMaxZoom: 10,
    hexagons1kmMaxZoom: 12,
    hexagons01kmMaxZoom: 14,
    disableProviderFilter: false,
  },
  mapServer: {
    url: 'https://statistics.nettest.com/api',
    country: 'norway',
  },
  municipality: {
    mapLayout: 'horizontal',
    forTesting: {
      name: 'Oslo',
      code: '0301',
      website: 'https://www.oslo.kommune.no',
    },
  },
  robotsMayIndex: true,
  versionName: 'nettest/portal-frontend',
  recaptchaSiteKey: '6LfWxp8kAAAAADqlZuWchiK47Hyoq-_2cQwG3Dmz',
}
